import { useParams, Link } from 'react-router-dom';
import { useEffect, useState } from 'react';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import useProperties, { PropertiesProps } from '../utils/useProperties';
import PropertyCard from '../components/PropertyCard';

type Property = {
    id: number;
    name: string;
    description: string;
    category: string;
    location: string;
    price: number;
    bed: number;
    bath: number;
    imgs?: string[];
};

const PropertyDetails = () => {
    const { id } = useParams<{ id: string }>();
    const [property, setProperty] = useState<PropertiesProps>();
    const [images, setImages] = useState<string[]>([]);
    const [related, setRelated] = useState<PropertiesProps[]>([]);

    const { properties, loading } = useProperties();

    useEffect(() => {
        if (properties && id) {
            const found = properties.find((item) => item.id.toString() === id);
            setProperty(found);

            if (found?.imgs) {
                setImages(found.imgs);
            }

            // Show related properties in the same category
            const relatedProps = properties.filter(
                (p) => p.category === found?.category && p.id.toString() !== id
            );
            setRelated(relatedProps);
        }
    }, [properties, id]);

    const settings = {
        customPaging: function (i: number) {
            return (
                <a className='!w-[60px]'>
                    <img
                        src={`https://akjodem.com/${images[i]}`}
                        alt={`thumb-${i}`}
                    />
                </a>
            );
        },
        dots: true,
        dotsClass: "slick-dots slick-thumb",
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
    };

    if (loading) return <p className="p-6">Loading...</p>;
    if (!property) return <p className="p-6">Property not found.</p>;

    return (
        <div className="px-[50px] pt-[100px]">
            <div className="pb-[100px] border-2">
                {images.length > 0 && (
                    <Slider {...settings}>
                        {images.map((img, index) => (
                            <div key={index}>
                                <img
                                    src={`https://akjodem.com/${img}`}
                                    alt={`property-${index}`}
                                    className="rounded w-full h-[650px] object-cover"
                                />
                            </div>
                        ))}
                    </Slider>
                )}
            </div>
            <div className='mt-[10px]'>
                <h2 className="mb-1 font-bold text-2xl">{property.name}</h2>
                <p className="mb-4 text-gray-600">{property.location}</p>
                <p className="mb-2 font-semibold text-lg">₦{Number(property.price).toLocaleString()}</p>
                <p className="mb-2">{property.bed} Bedrooms | {property.bath} Bathrooms</p>
                <p className="mb-6 text-gray-700">{property.description}</p>

            </div>

            {/* Related Properties */}
            <div className="mt-10">
                <h3 className="mb-4 font-semibold text-xl">Related Properties</h3>
                <div className="gap-8 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
                    {
                        related.length > 0 ?
                            related.slice(0, 3).map((item) => (
                                <Link to={`/properties/${item.category}/${item.id}`}>
                                    <PropertyCard
                                        key={item.id}
                                        title={item.name}
                                        desc={item.description}
                                        price={Number(item.price).toLocaleString()}
                                        imageUrl={`https://akjodem.com/${item.imgs?.[0]}`}
                                        bedrooms={item.bed}
                                        bathrooms={item.bath}
                                        area={item.sqft}
                                        sold={item.sold}
                                        featured={item.featured}
                                    />
                                </Link>
                            )):
                            <div className="col-span-full text-gray-900 text-2xl">
                        No related properties found.
                    </div>
                    }
                </div>
            </div>
        </div>
    );
};

export default PropertyDetails;
